module.exports = __webpack_public_path__ + "img/namskra.e26c231d.svg";